import { apiClient } from "@/lib/http";
import {
  type ResourceStore,
  createResourceStore,
  type ID,
} from "@/lib/resource";
import type { Business } from "./Business";
import type { Location } from "./Location";
import type { Asset } from "./Asset";
import type { Shop } from "./Shop";

export interface User {
  id: string;
  username: string;
  first_name: string;
  phone_number: string;
  last_name: string;
  email: string;
  image: Asset;
  is_staff: boolean;
  status: string;
  role: string;
  business_id?: ID;
  shop_id?: ID;
  location: Location;
  location_id?: ID;
  created_at: Date | string;
  updated_at: Date | string;
  email_verified_at: Date | string;
  business: Business;
  login_histories: LoginHistory[];
}

export interface LoginHistory {
  id: string;
  user_id: string;
  login_at: string; // ISO date string
  ip_address?: string | null;
  user_agent?: string | null;
  location?: string | null;
  created_at: string; // ISO date string
  updated_at: string; // ISO date string
}

interface UserStore extends ResourceStore<User> {
  updateCurrentShop: (shop_id: string) => Promise<any>;
  changePassword: (id: string, data: any) => Promise<any>;
  getShops: (id: string) => Promise<Shop[]>;
}

export const getFullName = (user: User | undefined) => {
  return user?.first_name != undefined && user?.last_name != undefined
    ? `${user?.first_name} ${user?.last_name}`
    : "";
};

export const useUser = createResourceStore<User, UserStore>("users", () => ({
  transform: (item: User) => {
    return {
      ...item,
      username: `${item?.first_name} ${item?.last_name}`,
      login_histories:
        item.login_histories == undefined ? item.login_histories : [],
    };
  },
  updateCurrentShop: (shop_id: string) => {
    return apiClient().post("/users/update-shop", { shop_id: shop_id });
  },
  changePassword: (id: string, data: any) => {
    return apiClient().put(`/users/change-password/${id}`, data);
  },
  getShops: (id: string) => {
    return apiClient()
      .get(`/users/${id}/shops`)
      .then((res) => {
        return Promise.resolve(res.data);
      });
  },
}));
